import React from 'react';
import { useState, useEffect } from 'react';
import { Text } from 'react-native';
import styled from 'styled-components/native';


function GameControlBar({endGameCallback}) {  
  return (
    <ControlBarParent> 
        <EndGameButton onPress={() => {endGameCallback({completed:1})}}>
            <EndGameText>
                I'm Finished
            </EndGameText>
        </EndGameButton>
    </ControlBarParent>
  );
}

export const ControlBarParent = styled.View`
  width: 100%;
  height:30px;
  background:white;
  box-shadow:3px 0px 1px black;
  justify-content:center;
  align-items:center;
`;

export const EndGameButton = styled.TouchableOpacity`
    width:200px;
    height:25px;
    background:white;
    border-radius:50px;
    justify-content:center;
    align-items:center;
    border:2px solid #3366cc
`

export const EndGameText = styled.Text`
    font-size:16px;
    color:#3366cc;
`

export default GameControlBar;